import React from 'react'

import {
  TaxesType,
  TypeElement
} from '@vio/core/src/api-types/bovio/response/offer_check'
import {Brand} from '@vio/core/src/brand/types'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {FeeTypes} from '.'

export const getTaxesAndFeesPopupHeaderText = (
  taxesAndFeesPopupState: string
) => {
  switch (taxesAndFeesPopupState) {
    case TypeElement.ResortFee:
      return (
        <FormattedMessageWrapper
          id="rate.resortFee"
          defaultMessage="Resort fee"
        />
      )
    case FeeTypes.PayAtProperty:
      return (
        <FormattedMessageWrapper
          id="paymentSchedule.payAtProperty"
          defaultMessage="Pay at property"
        />
      )
    case FeeTypes.ToCompleteTheBooking:
      return (
        <FormattedMessageWrapper
          id="paymentSchedule.toCompleteTheBooking"
          defaultMessage="To complete the booking"
        />
      )
    case TypeElement.CityTax:
      return (
        <FormattedMessageWrapper id="rate.cityTax" defaultMessage="City tax" />
      )
    case TypeElement.ServiceCharge:
      return (
        <FormattedMessageWrapper
          id="rate.serviceCharge"
          defaultMessage="Service charge"
        />
      )
    case TypeElement.CleaningFee:
      return (
        <FormattedMessageWrapper
          id="rate.cleaningFee"
          defaultMessage="Cleaning fee"
        />
      )
    case TypeElement.DestinationFee:
      return (
        <FormattedMessageWrapper
          id="rate.destinationFee"
          defaultMessage="Destination fee"
        />
      )
    case TypeElement.EnvironmentFee:
      return (
        <FormattedMessageWrapper
          id="rate.environmentFee"
          defaultMessage="Environment fee"
        />
      )
    case TypeElement.GoodsAndServicesTax:
      return (
        <FormattedMessageWrapper
          id="rate.goodsAndServicesTax"
          defaultMessage="Goods and services tax"
        />
      )
    case TypeElement.GovernmentTax:
      return (
        <FormattedMessageWrapper
          id="rate.governmentTax"
          defaultMessage="Government tax"
        />
      )
    case TypeElement.MunicipalityFee:
      return (
        <FormattedMessageWrapper
          id="rate.municipalityFee"
          defaultMessage="Municipality fee"
        />
      )
    case TypeElement.Other:
      return (
        <FormattedMessageWrapper
          id="rate.other"
          defaultMessage="Other local fees"
        />
      )

    case TypeElement.TourismFee:
      return (
        <FormattedMessageWrapper
          id="rate.tourismFee"
          defaultMessage="Tourism fee"
        />
      )
    case TaxesType.Tax:
      return (
        <>
          <FormattedMessageWrapper id="rate.tax" defaultMessage="Tax" />
          {/* Extra space at the end to maintain the dotted line below */}
          &nbsp;
        </>
      )

    case TypeElement.LocalVat:
    case TaxesType.Vat:
      return <FormattedMessageWrapper id="rate.vat" defaultMessage="VAT" />

    default:
    case FeeTypes.TaxesFees:
      return (
        <FormattedMessageWrapper
          id="taxesFees"
          defaultMessage="Taxes and fees"
        />
      )
  }
}

export const getTaxesAndFeesPopupBodyText = (
  taxesAndFeesPopupState: string,
  brandName: Brand['name']
) => {
  switch (taxesAndFeesPopupState) {
    case TypeElement.ResortFee:
      return (
        <FormattedMessageWrapper
          id="taxesAndFeesPopupHeaderText.resortFee"
          defaultMessage="This property charges a mandatory resort fee that will be collected either at check-in or check-out. This fee may cover access to certain amenities and services offered by the property."
        />
      )
    case FeeTypes.PayAtProperty:
      return (
        <FormattedMessageWrapper
          id="taxesAndFeesPopupHeaderText.payAtPropertyFee"
          defaultMessage="Charges payable at the property are mandatory taxes set by local authorities and/or property imposed fees. These will be collected by the property at check-in or check-out, regardless of where you book."
        />
      )
    case FeeTypes.ToCompleteTheBooking:
      return (
        <FormattedMessageWrapper
          id="taxesAndFeesPopupHeaderText.toCompleteBooking"
          defaultMessage="What you will need to pay to complete the booking of the Frozen Deal."
        />
      )
    case TaxesType.Tax:
      return (
        <FormattedMessageWrapper
          id="taxesAndFeesPopupHeaderText.tax"
          defaultMessage="Includes mandatory taxes (like sales tax or VAT) that {brandName} collects and pays to tax authorities."
          values={{
            brandName
          }}
        />
      )
    default:
    case FeeTypes.TaxesFees:
      return (
        <FormattedMessageWrapper
          id="taxesAndFeesPopupHeaderText.taxesAndFees"
          defaultMessage="Taxes and fees are generally recovery charges {brandName} pays to its partners (e.g. hotels)."
          values={{
            brandName
          }}
        />
      )
  }
}
